export default "__VITE_ASSET__DnGW2Fnx__"